<div class="rackDataHistory" *ngIf="data.type === 'RackHistory'">
  <mat-accordion>
    <section class="mat-header-row">
      <span class="mat-header-cell">{{'Rack Code' | translate}}</span>
      <span class="mat-header-cell">{{'Initial Upload Date' | translate}}</span>
      <span class="mat-header-cell">{{'Last Modified Date' | translate}}</span>
      <span class="mat-header-cell">{{'Last Updated By' | translate}}</span>
    </section>
    <ng-container *ngIf="historyDataSource">
      <mat-expansion-panel *ngFor="let rack of [historyDataSource]">
        <mat-expansion-panel-header class="mat-row">
          <span class="mat-cell">{{rack.code}}</span>
          <span class="mat-cell">{{rack.initialUploadDate | date:'yyyy-MM-dd'}}</span>
          <span class="mat-cell">{{rack.lastModifiedDate | date:'yyyy-MM-dd'}}</span>
          <span class="mat-cell">{{rack.userName}}</span>
        </mat-expansion-panel-header>
        <mat-table class="rackTable" #table [dataSource]="rack.history">
          <ng-container *ngFor="let metaData of rackHistoryMetaData" [matColumnDef]="metaData.field">
            <mat-header-cell *matHeaderCellDef sticky=true>{{metaData.header | translate}} </mat-header-cell>
            <mat-cell *matCellDef="let element"
              [ngClass]="{dataChanged: element.changes && element.changes[metaData.field]}">
              {{metaData.field === "timeStamp" ? (element[metaData.field] | date:'yyyy-MM-dd HH:mm:ss') :
              element[metaData.field]}}</mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="rackHistoryFields"></mat-header-row>
          <mat-row *matRowDef="let row; columns: rackHistoryFields;"></mat-row>
        </mat-table>
      </mat-expansion-panel>
    </ng-container>
  </mat-accordion>
  <div mat-dialog-actions class="fileUploadActionButtons">
    <div>
      <button class="okButton" mat-button (click)="onNoClick()">{{'Close' | translate}}</button>
    </div>
  </div>
</div>


<div class="rackDataHistory" *ngIf="data.type === 'NoubaHistory'">
  <mat-accordion>
    <section class="mat-header-row">
      <span class="mat-header-cell">{{'Nouba Code' | translate}}</span>
      <span class="mat-header-cell">{{'Initial Upload Date' | translate}}</span>
      <span class="mat-header-cell">{{'Last Modified Date' | translate}}</span>
      <span class="mat-header-cell">{{'Last Updated By' | translate}}</span>
    </section>
    <ng-container *ngIf="historyDataSource">
      <mat-expansion-panel *ngFor="let nouba of [historyDataSource]">
        <mat-expansion-panel-header class="mat-row">
          <span class="mat-cell">{{nouba.code}}</span>
          <span class="mat-cell">{{nouba.initialUploadDate | date:'yyyy-MM-dd'}}</span>
          <span class="mat-cell">{{nouba.lastModifiedDate | date:'yyyy-MM-dd'}}</span>
          <span class="mat-cell">{{nouba.userName}}</span>
        </mat-expansion-panel-header>
        <mat-table class="rackTable" #table [dataSource]="nouba.history">
          <ng-container *ngFor="let metaData of noubaHistoryMetaData" [matColumnDef]="metaData.field">
            <mat-header-cell *matHeaderCellDef sticky=true>{{metaData.header | translate}} </mat-header-cell>
            <mat-cell *matCellDef="let element"
              [ngClass]="{dataChanged: element.changes && element.changes[metaData.field]}">
              {{metaData.field === "timeStamp" ? (element[metaData.field] | date:'yyyy-MM-dd HH:mm:ss') :
              element[metaData.field]}}</mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="noubaHistoryFields"></mat-header-row>
          <mat-row *matRowDef="let row; columns: noubaHistoryFields;"></mat-row>
        </mat-table>
      </mat-expansion-panel>
    </ng-container>
  </mat-accordion>
  <div mat-dialog-actions class="fileUploadActionButtons">
    <div>
      <button class="okButton" mat-button (click)="onNoClick()">{{'Close' | translate}}</button>
    </div>
  </div>
</div>